import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from "./store"
import VueSocketIO from 'vue-socket.io'
import VueMeta from 'vue-meta'
import VueClipboard from 'vue-clipboard2'
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';

// import VueAnalytics from 'vue-analytics'

// Vue.use(VueAnalytics, {
//   id: 'UA-189093519-2',
//   checkDuplicatedScript: true
// })


Vue.use(new VueSocketIO({
    debug: false,
    connection: 'https://chat.resolved.gg',
    vuex: {
        store,
        actionPrefix: 'SOCKET_',
        mutationPrefix: 'SOCKET_'
    },
}))

Vue.use(VueMeta, {
    refreshOnceOnNavigation: true
})


Vue.use(VueClipboard)
Vue.use(VueToast);
export const toastInstance = Vue.$toast;


Vue.config.productionTip = false


new Vue({
    store,
    router,
    render: h => h(App),
}).$mount('#app')